import axios from "axios";

const API = axios.create({
  baseURL: "http://localhost:4000", // backend port
  // withCredentials: true,
});

export default API;
